import moment from 'moment'

export const dateFormat = val => {
  if (val) {

    return moment(val).format('DD/MM/YYYY')
  }
  return '-'
};

export const dateTimeFormat = val => {
  if (val) {

    return moment(val).format('DD/MM/Y H:m') + ' hs'
  }
  return '-'
}

export const currencyFormat = val => {
  let result = 0;
  if(!isNaN(val)) {
    result = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currency: 'ARS',
      style: 'currency'
    }).format(val);
  }
  return result;
};
export const currencyFormatUsd = val => {
  let result = 0;
  if(!isNaN(val)) {
    result = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currency: 'USD',
      style: 'currency'
    }).format(val);
  }
  return result;
};

export const intFormat = val => {
  let result = 0;
  if (!isNaN(val)) {
    result = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(val);
  }
  return result;
};

export const numberFormat = val => {
  if (!isNaN(val)) {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(val)
  } else {
    return 0
  }
}

export const lower = val => val ? val.toLowerCase() : '';
